module.exports = __webpack_public_path__ + "img/bad.73881933.svg";